// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"d134611f","486":"7956d908","834":"b67ade04"}[chunkId] + ".chunk.js";
};